import { ICanvasGradient, ICanvasRenderingContext } from 'babylonjs';
import * as BABYLONGUI from 'babylonjs-gui';

export class Scripted3dControlGradientRectangle extends BABYLONGUI.Rectangle {

  private _gradientVertical : boolean;
  set gradientVertical(value) {
    this._gradientVertical = value ? true : false;
  }
  get gradientVertical() {
      return this._gradientVertical;
  }

  private _gradientStops : {offset : number, color : string}[] = [];
  get gradientStops() {
      return this._gradientStops;
  }

  set gradientStops(value) {
    this._gradientStops = value;
  }


  constructor(name){
        super(name);
    }

    protected override _getColor(context: ICanvasRenderingContext): string | ICanvasGradient {
      return this.color;
    }

    protected override _localDraw(context: ICanvasRenderingContext) {
        context.save();

        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }

        if(this._gradientVertical){
          // @ts-ignore
          this._gradient = context.createLinearGradient(0, this._currentMeasure.top, 0, this._currentMeasure.top + this._currentMeasure.height);
        }
        else {
          // @ts-ignore
            this._gradient = context.createLinearGradient(this._currentMeasure.left, 0, this._currentMeasure.left + this._currentMeasure.width, 0);
        }

        if (this._gradientStops) {
          for (let i = 0; i < this._gradientStops.length; i++) {
            // @ts-ignore
            this._gradient.addColorStop(this._gradientStops[i].offset, this._gradientStops[i].color);
          }

          // @ts-ignore
          context.fillStyle = this._gradient;
        }

        // @ts-ignore
        if (this._cornerRadius) {
          // @ts-ignore
            this._drawRoundedRect(context, this._thickness / 2);
            context.fill();
        } else {
            context.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
        }

        // @ts-ignore
        if (this._thickness) {
            if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                context.shadowBlur = 0;
                context.shadowOffsetX = 0;
                context.shadowOffsetY = 0;
            }

            if (this.color) {
                context.strokeStyle = this.color;
            }
            // @ts-ignore
            context.lineWidth = this._thickness;

            // @ts-ignore
            if (this._cornerRadius) {
              // @ts-ignore
                this._drawRoundedRect(context, this._thickness / 2);
                context.stroke();
            } else {
              // @ts-ignore
                context.strokeRect(this._currentMeasure.left + this._thickness / 2, this._currentMeasure.top + this._thickness / 2, this._currentMeasure.width - this._thickness, this._currentMeasure.height - this._thickness);
            }
        }

        context.restore();
    }
}
